import React from 'react';
import remoteFiles from '../../../common/remote_files';
import FooterSocialMenu from "./components/footerSocialMenu";

const OpenBank = ({ emailData }) => {
  const learnUrl = remoteFiles.verizon.emailApp.concept1.learn;
  return (
    <div className="email">
      <div className="email_header -no-border">
        <div className="email_header-logo">
          <svg className="email_header-logo-img">
            <use xlinkHref={ `#svg_verizon-long-branded` } />
          </svg>
        </div>
        <ul className="email_header-menu">
          <li>Shop</li>
          <li>Support</li>
          <li>My Verizon</li>
        </ul>
      </div>
      <div className="email_hero -stone -openbank -red-border">
        <div className="email_hero-content -center">
          <h1 className="email_hero-title -red -bigger">
            Grow your savings
            <br />
            Shrink your wireless bill
          </h1>
          <div className="email_hero-text -small -short">
            Introducing Verizon + Openbank Savings, a high-yield savings account that helps you get more for your money. Earn 4.30% APY, plus get up to $180 off your wireless bill for up to 12 months. Only for Verizon customers.
          </div>
          <div className="email_hero-button">
            <div className="email_button -red">Learn more</div>
          </div>
          <div className="email_hero-decor">
            <div className="email_squares-decor -red" />
          </div>
          <div className="email_hero-logos -increase30">
            <div className="email_hero-logo">
              <svg className="email_hero-logo-img -vz">
                <use xlinkHref={ `#svg_verizon-long-branded` } />
              </svg>
            </div>
            <div className="email_hero-logo -separator" />
            <div className="email_hero-logo">
              <svg className="email_hero-logo-img -openbank">
                <use xlinkHref={ `#svg_openbank-logo` } />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="email_content">
        <div className="email_content-section">
          <div className="email_content-intro">
            <h2 className="email_content-intro-title">
              Benefits that make
              <br />
              dollars and sense
            </h2>
            <div className="email_content-intro-text">
              { emailData.name }, we’re always working to keep you connected and give you more value. That’s why we’ve partnered with Openbank, bringing you new ways to earn and save with an exclusive discount.
            </div>
          </div>
        </div>

        <div className="email_content-section">
          <div className="email_savings-openbank">
            <div className="email_savings-openbank-info">
              <div className="email_savings-openbank-info-title">
                Verizon + Openbank Savings
              </div>
              <div className="email_savings-openbank-info-value">
                4.30%
                <small>APY</small>
              </div>
              <div className="email_savings-openbank-info-text">
                That’s 10X the national savings average, all with no additional fees.
              </div>
            </div>

            <div className="email_savings-openbank-details">
              <table className="email_savings-openbank-table">
                <thead>
                  <tr>
                    <th colSpan={ 2 }>
                      Estimated bill savings in a year
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="-accent">
                      Average daily balance per month
                    </td>
                    <td className="-accent">
                      Discount per year
                    </td>
                  </tr>
                  <tr>
                    <td>$1,000</td>
                    <td>Up to $60</td>
                  </tr>
                  <tr>
                    <td>$10,000</td>
                    <td>Up to $120</td>
                  </tr>
                  <tr>
                    <td>$30,000</td>
                    <td>Up to $180</td>
                  </tr>
                  <tr>
                    <td colSpan={ 2 }>
                      Savings applied as monthly credits on your wireless bill on top of current discounts for Auto Pay, Mobile + Home and more.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="email_content-section">
          <div className="email_about-openbank-raw">
            <img src={ learnUrl } alt="" />
          </div>
        </div>

        <div className="email_content-section">
          <div className="email_banner -grid -big-padding">
            <div className="email_banner-image -in-grid">
              <svg className="email_banner-image-img">
                <use xlinkHref={ `#svg_verizon-short-branded` } />
              </svg>
            </div>
            <div className="email_banner-content -in-grid -big">
              We got you covered
            </div>
          </div>
        </div>
      </div>

      <div className="email_footer">
        <ul className="email_footer-menu -main">
          <li>Phones</li>
          <li>Accessories</li>
          <li>Plans</li>
          <li>Verizon Access</li>
          <li>My Verizon app</li>
          <li>Contact us</li>
        </ul>
        <FooterSocialMenu />

        <div className="email_footer-texts -black -concept1-margins">
          <p>
            Verizon + Openbank Savings is offered exclusively by Openbank, a division of Santander Bank, N.A., and is not managed, housed, or controlled by Verizon. Santander Bank, N.A., offering your account through its Openbank division, is a Federal Deposit Insurance Corporation (“FDIC”) insured institution. Deposits at Santander Bank, N.A. and its Openbank division are combined for FDIC insurance purposes (FDIC Cert. 29950) and are not separately insured. There is a maximum of $250,000 of deposit insurance from the FDIC per depositor for each category of account ownership. Please visit <span className="underline">fdic.gov</span> for details. Verizon is not a chartered banking institution and is not insured by FDIC.
          </p>
          <p>
            The APY comparison is based upon the national average for “Savings” deposit products as published in the FDIC National Rates and Rate Caps on <span className="underline">fdic.gov</span> of 0.41%, accurate as of 4.21.25.
          </p>
          <p>
            <b>
              Verizon + Openbank Bill Credit Eligibility and Calculation:</b> Eligible customers must have a mobile telephone number associated with a postpaid consumer wireless account offered by Verizon within the United States (the “Verizon Account”).
            { ' ' }
            <i>To receive a credit on your Verizon bill (the “Verizon + Openbank Bill Credit”), you must submit an application for an Openbank high-yield savings account (the “Deposit Account”) using the application link provided on Verizon’s website or mobile app.</i>
            { ' ' }
            The amount of the Verizon Bill + Openbank Credit will be determined as follows: $5 per month for an average Deposit Account balance between $1,000 and $9,999.99 for up to 12 consecutive months from the date your Deposit Account is opened; $10 per month for an average Deposit Account balance between $10,000 and $29,999.99 for up to 12 consecutive months from the date your Deposit Account balance is opened; and $15 per month for an average Deposit Account balance equal to or greater than $30,000 for up to 12 consecutive months from the date your Deposit Account is opened.
          </p>

          <p>The monthly average Deposit Account balance will be calculated on your Deposit Account statement date (once every month) and is mathematically derived as a daily average. If you do not maintain a qualifying Deposit Account balance in any given month, you will not receive a Verizon + Openbank Bill Credit for that month, but there will be no impact on your customer status or interest rate with Openbank. You may not be eligible for a Verizon + Openbank Bill Credit after 12 months from the date your Deposit Account is opened. If your Deposit Account or Verizon Account closes for any reason, or if the mobile telephone number associated with your Verizon Account is terminated, you will not be eligible for a full or partial Verizon + Openbank Bill Credit for that month or any
            future month.
          </p>

          <p>
            <b>Multiple Accounts:</b> If you have more than one Deposit Account, you are only eligible to receive a Verizon + Openbank Bill Credit as to the first Deposit Account you open. If other individuals on your Verizon Account also maintain Deposit Accounts, the Verizon + Openbank Bill Credit will be applied only as to the first two individuals to open a Deposit Account. In any event, a maximum of two Verizon + Openbank Bill Credits may be applied to any Verizon Account. The maximum Verizon + Openbank Bill Credit obtainable is with two (2) accounts, each with minimum $30,000 average balances, resulting in a combined bill credit of $30 monthly, totaling $360 over 12 months.
          </p>

          <p>
            <b>Verizon + Openbank Bill Credit Application:</b> If you qualify for a Verizon + Openbank Bill Credit, the Verizon + Openbank Bill Credit will be applied to your Verizon bill beginning within 2–3 Verizon bill cycles following the issuance of your initial Deposit Account statement. Verizon is solely responsible for applying the Verizon + Openbank Bill Credit based on Deposit Account balance information provided by Openbank.
          </p>
          <p>
            The Openbank high-yield savings account is a variable-rate account, and the rate applicable may change at any time without notice. Availability for this product will be based on the residential zip code entered when account is opened within the online application process. Offer subject to change or cancellation at any time without notice. All account applications are subject to approval by Openbank.
          </p>

          <p>
            Interest Rates and Annual Percentage Yields (APYs) shown are accurate and effective as of 3.27.25. The products and rates we offer may vary between locations, are available in select markets only, and are subject to change without notice. This is a variable-rate account, and the rate may change at any time without notice. A minimum opening deposit of $500 is required to open a Verizon + Openbank Savings account. Personal accounts only. For more information about applicable terms, refer to the Openbank Personal Deposit Account Agreement and Verizon Addendum.
          </p>

          <p>
            © 2025 Verizon
          </p>

          <p>
            This email was sent to { emailData.receiver }. We respect your privacy. Please review our <span className="underline">Privacy Policy</span>. California
            customers can view our <span className="underline">California Privacy Notice</span>. You may <span className="underline">unsubscribe</span> or update your subscription preferences for your Verizon promotional emails at any time.
          </p>

          <p>
            Verizon, One Verizon Way, Mail Code: 180WVB, Basking Ridge, NJ 07920
          </p>
        </div>
      </div>
    </div>
  );
};

export default OpenBank;
